module.exports = __webpack_public_path__ + "assets/backbone.acf8a2fd.svg";